import { ENV } from '../types/internal';

export const environment: ENV = {
  debug: false,
  git_sha: process.env['GIT_SHA'],
  django_login_url: 'https://staging-login.presence.com',
  sirius_url: 'https://staging-api.presence.com/sirius/v1',
  apps: {
    auth: 'https://staging-api.presence.com/login',
    kanga: 'https://staging-api.presence.com/kanga',
    library: 'https://staging-library.presence.com',
    room: 'https://staging-room.presence.com',
    gateway: 'https://staging-api.presence.com',
    presence: 'https://staging-apps.presence.com/c',
  },
  room_share_base_url: '',
  setup_url: 'https://staging-room.presence.com/pl/setup',
  support_email: 'asksupport@presence.com',
  support_phone: '18444154592',
  pendo_key: '',
  heap_key: '',
  fullstory_key: '',
  sentry_dsn:
    process.env['SENTRY_DSN'] ||
    'https://18e08e9f21eb410ab8ffa171bbfdc169@o7007.ingest.sentry.io/4504803481288704',
  baa_sign_url:
    'https://secure.na2.adobesign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhALU7FzuS4b4fW4VFk56-7PG8F0bqEaU-dqBpn-S20lRD5e7R-WahGE1r8marlO034*',
  learnupon_url: 'presencedev.learnuponus.com',
  config_cat_sdk: 'DgLbCHEjckGEDa0uS7QeUQ/qk_kfWVfR02ZUx1-WNEmXg',
  // OIDC client_id
  // For preview environments, CircleCI sets OIDC_CLIENT_ID after registration
  // Otherwise use staging default
  oidc_client_id: process.env['OIDC_CLIENT_ID'] || 'kanga-staging',
  room_oidc_client_id: 'room-staging',
  presence_oidc_client_id: 'edu-clients-staging',
  // Set by CircleCI's PREVIEW_ALIAS for a preview build; undefined for a
  // regular staging build.
  preview_alias: process.env['PREVIEW_ALIAS'] || undefined,
  cookie_domain: 'presence.com',
  // The app supports django and sirius at the same time. This value alone selects which one is used.
  // See getIsSiriusEnabled() in src/app/common/sirius-util.ts.
  use_sirius: true,
  cdn_url: 'https://pleiades-cdn.pages.dev',
  zendesk: {
    webWidget: {
      authUrl: 'https://staging-api.presence.com/auth/token/zendesk',
      tokenExchangeUrl:
        'https://staging-api.presence.com/sirius/v1/oidc/oauth/token',
      conversationFields: {
        contactEmail: '46453092447507',
        contactName: '46453100450323',
      },
    },
  },
};
